export default
    {
        path: "/help",
        component: () => import('../view/help/helpMain.vue'),
        children: [
            {
                path: 'WearableHelp',
                name: 'WearableHelp',
                component: () => import('../view/help/WearableHelp.vue')
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/helpRouter.js